import React from 'react'
import '../News/News.css'
import { Link } from 'react-router-dom'

//Assets
import shreeKant from "../../../assets/images/srikant press release (2).png"

const  News=()=> {
    
    const array=[
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/Women%20Behind%20the%20Wheel_300%20X%20300%20px_Desktop%20Homepage.jpg`,
            paragragh:"NueGo Celebrates World Driver’s Day by Empowering Women Behind the Wheel",
            link:"#Blog1"
        },
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/NueGo-Diwali_300%20X%20300%20px_Desktop%20Homepage.jpg`,
            paragragh:'This Diwali, Travel Green, Noiseless, and Safe with NueGo',
            link:"#Blog2"
        },
        {
            img:`${process.env.REACT_APP_IMAGEBASE_URL}/CC Training 2-Pica_300-X-300-px_Desktop-Home-Pg.webp`,
            paragragh:"NueGo Equip its Coach Captains with Skills and Technology to Drive India’s Green Mobility Movement",
            link:"#Blog3"
        },

  
    ]

    return (

        <section className='news_section'>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h2>Recent News</h2>
                        <div className='news-list'>
                        <ul>
                            {array.map((items,id)=>{
                              return  <li  className='imagenewsss' >                                   
                              <img src={items.img} alt="blog1"  className='imagessss' />
                              <p>{items.paragragh} ​</p>
                              <Link  to={`/news${items.link}`} >Read More 
                               {/* <img src={blogarrow} alt='blogarrow img' />  */}
                               <img src={`${process.env.REACT_APP_IMAGEBASE_URL}/arrow.svg`} alt='blogarrow img'    />   
                               </Link>
                            </li>
                            }) }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    )
}

export default News
